import React, {useEffect, useState} from "react";
import Table from "../../../../../../base/components/Table";
import { useService } from "../../../../../../base/hooks/useService";
import { useLocationQuery } from "../../../../../../base/hooks/useQueryString";
import { useTable } from '../../../../../../base/hooks/useTable';
import tableStructure from "./tableStructure";
import TableHeader from './TableHeader';
import { Container } from "reactstrap";
import {SEARCH_QUERY, SORT_KEY, SORT_TYPE} from "../../../../../../base/constants/query";
import EventsService from "../../../../../../services/EventsService";
import webSocketService from "../../../../../../services/WebSocketService";
import {SOCKET_EVENTS} from '../../../../constants/socket'

const EVENTS_LIMIT = 15;

export const EventsList = ({eventsParams}) => {
  /**
   * @type {EventsService}
   */
  const eventsService = useService(EventsService);
  const [update, setUpdate] = useState(false);
  const { params } = useLocationQuery();

  const [loading, pagination, data, handleTableChange, downloadNewData] = useTable({
    searchQueryParam: SEARCH_QUERY,
    sortTypeQueryParam: SORT_TYPE,
    sortByQueryParam: SORT_KEY,
    getNewDataService: eventsService.getEvents.bind(eventsService),
    limit: EVENTS_LIMIT,
    defaultSort: eventsParams,
    offset: params.offset || 0
  })

  const textPlaceholder = !params[SEARCH_QUERY] ? 'There are no events' : 'No search results found';

  const updateData = async () => {
    setUpdate(true)
    await downloadNewData()
    setUpdate(false)
  }

  webSocketService.onMessage({
    [SOCKET_EVENTS.EVENT_CREATED]: updateData,
    [SOCKET_EVENTS.EVENT_SUSPENDED_UNSUSPENDED]: updateData,
    [SOCKET_EVENTS.EVENT_DELETED]: updateData,
    [SOCKET_EVENTS.EVENT_EDITED]: updateData,
  })

  return (
      <Container fluid className="p-0">
        <Table
          data={data}
          dataStructure={tableStructure}
          loading={!update && loading}
          HeaderComponent={TableHeader}
          limit={EVENTS_LIMIT}
          offset={params.offset || 0}
          totalCount={pagination.totalCount}
          handleTableChange={handleTableChange}
          searchField={SEARCH_QUERY}
          textPlaceholder={textPlaceholder}
        />
      </Container>
  );
};
